import { BuildContext, ExportOptions, ExportPayloadSection } from '../../types';
import appendJsonRows from './appendJsonRows';

const buildJsonContent = async (
  sections: ExportPayloadSection[],
  options: ExportOptions,
  context: BuildContext
): Promise<string> => {
  const isSingleRootExport = sections.length === 1;
  const lines: string[] = ['{'];

  if (isSingleRootExport) {
    const rootSection = sections[0];
    lines.push(`  "table": ${JSON.stringify(rootSection.id)},`);
    lines.push(`  "name": ${JSON.stringify(rootSection.label)},`);
    lines.push('  "rows": [');
    await appendJsonRows(
      lines,
      rootSection.rows,
      rootSection.columns,
      options,
      '    ',
      context,
      rootSection.childSections,
      rootSection.masterIdItem
    );
    lines.push('  ]');
  } else {
    lines.push('  "sections": [');
    for (
      let sectionIndex = 0;
      sectionIndex < sections.length;
      sectionIndex += 1
    ) {
      const section = sections[sectionIndex];
      const isLastSection = sectionIndex === sections.length - 1;
      lines.push('    {');
      lines.push(`      "id": ${JSON.stringify(section.id)},`);
      lines.push(`      "label": ${JSON.stringify(section.label)},`);
      lines.push('      "rows": [');
      await appendJsonRows(
        lines,
        section.rows,
        section.columns,
        options,
        '        ',
        context
      );
      lines.push('      ]');
      lines.push(`    }${isLastSection ? '' : ','}`);
    }
    lines.push('  ]');
  }

  lines.push('}');

  return lines.join('\n');
};

export default buildJsonContent;
